<template>
  <div>
    <HomeHeader />
    <div ref="top" style="padding-top: 70px;width: 100%;min-height: 73.8vh">
      <el-container >
        <el-main style="padding: 20px 0;margin: 0 10%">
          <div class="content">
            <div class="content_left">
              <el-popover
                  v-model="authorAvatar"
                  placement="bottom"
                  width="700"
                  trigger="click"
              >
                <div class="popover_body">
                  <div class="popover_head">
                    <img v-if="!detail.userInfo.headPortrait || detail.userInfo.headPortrait === ''" src="@/assets/img/forum/forum_user.png" alt="">
                    <img v-else :src="detail.userInfo.headPortrait" alt="">
                    <div class="popover_message">
                      <div>
                        <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 160px;" :title="detail.author">{{detail.author}}</div>
                        <div class="popover_tab">LV{{(authorInfoPop.level== null || authorInfoPop.level === '0' ? '1' : authorInfoPop.level)}} {{authorInfoPop.levelName}}</div>
                      </div>
                      <div style="color: #999999;font-size: 14px;padding-top: 14px;justify-content: flex-start">
                        <div style="width:120px;">{{authorInfoPop.levelRumenOrZhuanye === '0' ? '产品原型设计' : '车载应用开发'}}</div>
                        <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 270px" :title="authorInfoPop.introduce === null || authorInfoPop.introduce === '' ? '暂无' : authorInfoPop.introduce">个人介绍：{{authorInfoPop.introduce === null || authorInfoPop.introduce === '' ? '暂无' : authorInfoPop.introduce}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="popover_foot">
                    <div>已发布的应用数：{{authorInfoPop.appSum}}</div>
                    <div>已发布的场景数：{{authorInfoPop.sceneSum}}</div>
                    <div>经验值：{{authorInfoPop.exp}}</div>
                    <div>性别： {{authorInfoPop.gender === '' || authorInfoPop.gender === null || authorInfoPop.gender === '0' ? '未公开' : (authorInfoPop.gender === '1' ? '男' : '女')}}</div>
                    <div v-if="authorAvatar">生日： {{!authorInfoPop.birthDay || authorInfoPop.birthDay === null || authorInfoPop.birthDay === '' ? '未公开' : authorInfoPop.birthDay}}</div>
                  </div>
                </div>

                <div slot="reference" class="content_user">
                  <div class="content_img">
                    <img v-if="!detail.userInfo.headPortrait || detail.userInfo.headPortrait === ''" src="@/assets/img/forum/forum_user.png" alt="">
                    <img v-else :src="detail.userInfo.headPortrait" alt="">
                  </div>
                  <div class="content_name">{{detail.author}}</div>
                  <div class="content_tab">
                    <div v-if="level[0]">
                      LV{{level[0].level}} {{level[0].levelName}}
                    </div>
                    <div v-else>
                      LV1 开发新星
                    </div>
                  </div>
                  <div class="content_message">
                    <span>文章</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{articleTotal}}</span>
                  </div>
                </div>
              </el-popover>
            </div>
            <div class="content_right">
              <div style="display: flex;align-items: center;padding: 18px 5px;">
                <div class="title">
                  {{detail.title}}
                  <!-- 学堂、论坛的分组标签全部隐掉 -->
                  <!-- <div class="tab1">{{channelName}}</div> -->
                  <div v-for="(item, index) in detail.tags" :key="'tag' + index" class="tab">{{item}}</div>
                </div>
              </div>
              <div class="time">
                <div v-if="(detail.createTime == detail.updateTime)">
                  发表于：{{timeFormatSeconds(detail.createTime)}}
                </div>
                <div v-else>
                  {{timeFormatSeconds(detail.updateTime)}}&nbsp;被作者编辑过
                </div>
                <div>浏览量：{{detail.views}}</div>
              </div>
              <div class="button">
                <div @click="findComments">{{seeAll}}</div>
                <div v-if="userId != detail.authorId" :class="collectionFlag ? 'cancelCollection' : ''" @click="collection(detail.id)">{{collectionName}}</div>
              </div>
              <div class="ql-bubble" >
                <div class="ql-editor detail" v-html="detail.content"></div>
              </div>
              <div class="operation">
                <i v-if="userId === detail.authorId" class="el-icon-edit" style="font-size: 16px;color: #999999;margin-right: 15px;cursor: pointer" @click="toDetail()"></i>
                <i v-if="userId === detail.authorId" class="el-icon-delete" style="font-size: 16px;color: #999999;margin-right: 15px;cursor: pointer" @click="delArticle"></i>
                <img v-show="thumbsFlag === 0" src="@/assets/icons/praise.svg" alt="" style="height: 20px;" @click="thumbs()">
                <img v-show="thumbsFlag === 1" src="@/assets/icons/liked.svg" alt="" style="height: 20px;" @click="thumbs()">
                <div style="padding: 0 15px 0 0;font-size: 12px;color: #999999">{{detail.thumbs}}</div>
                <img v-if="userId != detail.authorId" src="@/assets/icons/report.svg" alt="" style="height: 20px" @click="report(detail.id, 'article')">
              </div>
            </div>
          </div>
          <div v-for="(item, index) in list" :key="`comment${index}`"  :ref="'comment' + index" class="comment">
            <div class="content_left">
              <div slot="reference" :ref='`bt${index}`' :class="item.userInfo.id === detail.authorId ? 'content_user' : 'comment_user'" @click='clickPop(index, item.userInfo)' >
                <div class="content_img">
                  <img v-if="!item.userInfo.headPortrait || item.userInfo.headPortrait === ''" src="@/assets/img/forum/forum_user.png" alt="">
                  <img v-else :src="item.userInfo.headPortrait"  alt="">
                </div>
                <div class="content_name">
                  {{item.userInfo.name}}
                </div>
                <div class="content_tab">
                  <div v-if="level[index + 1]">
                    LV{{level[index + 1].level}} {{level[index + 1].levelName}}
                  </div>
                  <div v-else>
                    LV1 开发新星
                  </div>
                </div>
                <div class="content_message">
                  <span>文章</span>
                  <el-divider direction="vertical"></el-divider>
                  <span>{{item.userInfo.article}}</span>
                </div>
              </div>
            </div>
            <div class="comment_right">
              <div class="comment_first">
                <div class="comment_first_content">
                  <div class="ql-bubble" >
                    <div class="ql-editor detail" v-html="item.content"></div>
                  </div>
                </div>
                <div style="display: flex;align-items: center;justify-content: space-between;font-size:14px">
                  <div v-if="(item.createDate == item.publishDate)" class="comment_first_time">{{ currentPage === 1 ? '' : currentPage - 1 }}{{ index + 1 }}楼 回复于{{timeFormatSeconds(item.publishDate)}}</div>
                  <div v-else class="comment_first_time">{{ currentPage === 1 ? '' : currentPage - 1 }}{{ index + 1 }}楼 {{timeFormatSeconds(item.publishDate)}}&nbsp;被作者编辑过</div>
                  <div class="comment_first_operation">
                    <i v-if="userId === item.userInfo.id" class="el-icon-edit" style="font-size: 16px;color: #999999;margin-right: 15px;cursor: pointer" @click="editNewComment(item)"></i>
                    <i v-if="userId === item.userInfo.id" class="el-icon-delete" style="font-size: 16px;color: #999999;margin-right: 15px;cursor: pointer" @click="delComment(item.id, '回复')"></i>
                    <img v-show="item.isThumbs === 0" src="@/assets/icons/praise.svg" alt="" style="height: 20px;" @click="commentThumbs(item, index)">
                    <img v-show="item.isThumbs === 1" src="@/assets/icons/liked.svg" alt="" style="height: 20px;" @click="commentThumbs(item, index)">
                    <div style="padding: 0 15px 0 0;font-size: 12px;color: #999999">{{item.thumbs}}</div>
                    <img src="@/assets/icons/content.svg" alt="" style="height: 20px;margin-right: 15px" @click="showComment(item, index)">
                    <img v-if="userId !== item.userInfo.id" src="@/assets/icons/report.svg" alt="" style="height: 20px;margin-right: 15px" @click="report(item.id, 'comment')">
                  </div>
                </div>
              </div>
              <div v-for="(children, childrenIndex) in contentPagination[index].list" :key="'children' + childrenIndex" class="comment_return">
                <div ref="commentBox" class="comment_return_content">
                  <img v-if="children.top === 1" src="@/assets/img/forum/forum_top.png" style="width: 24px;height: 24px;margin-right: 7px" alt="">
                  <img v-if="!children.userInfo.headPortrait || children.userInfo.headPortrait === ''" src="@/assets/img/forum/forum_user.png" alt="">
                  <img v-else :src="children.userInfo.headPortrait"  alt="">
                  <div class="name">{{children.userInfo.name}}</div>
                  <div class="content" v-html="children.content"></div>
                </div>
                <div class="comment_return_time">
                  <div>发表于：{{timeFormatSeconds(children.publishDate)}}</div>
                  <div class="button">
                    <i v-if="userId === children.userId" class="el-icon-delete" style="font-size: 16px;color: #999999;margin-right: 15px;cursor: pointer" @click="delComment(children.id, '评论')"></i>
                    <img v-show="children.isThumbs === 0" src="@/assets/icons/praise.svg" alt="" style="height: 20px;" @click="commentThumbs(children, index, childrenIndex)">
                    <img v-show="children.isThumbs === 1" src="@/assets/icons/liked.svg" alt="" style="height: 20px;" @click="commentThumbs(children, index, childrenIndex)">
                    <div style="padding: 0 15px 0 0;font-size: 12px;color: #999999">{{children.thumbs}}</div>
                    <img v-if="userId !== children.userId" src="@/assets/icons/report.svg" alt="" style="height: 20px" @click="report(children.id, 'comment')">
                  </div>
                </div>
              </div>
              <el-pagination
                  v-if="contentPagination[index]"
                  class="comment_pagination"
                  background
                  :current-page.sync="contentPagination[index].pageNum"
                  :page-size="8"
                  layout="prev, pager, next, total"
                  :total="contentPagination[index].total"
                  :hide-on-single-page="true"
                  @current-change="showAllComment(index, item.id)">
              </el-pagination>
              <div v-if="item.childrenTotal > 3 && !contentPagination[index].showFlag" class="allContent">
                <p @click="showAllComment(index, item.id)">展示共{{item.childrenTotal}}条回复</p>
              </div>
              <div v-if="item.childrenTotal > 3 && contentPagination[index].showFlag" class="allContent">
                <p @click="hideAllComment(index)">收起回复</p>
              </div>
              <div v-if="divIndex.indexOf(index) !== -1" class="comment_div">
                <div class="comment_add">
                  <quill-editor
                      :ref="'commentQuillEditor' + index"
                      v-model="comment[index].content"
                      :options="commentOption"
                  />
                  <!--                  <el-input-->
                  <!--                      v-model="textarea"-->
                  <!--                      class="comment_textarea"-->
                  <!--                      type="textarea"-->
                  <!--                      :autosize="{ minRows: 4 }"-->
                  <!--                  >-->
                  <!--                  </el-input>-->
                  <div class="upload">
                    <el-upload
                        class="avatar-uploader"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        accept="image/gif, image/jpeg, image/jpg, image/bmp, image/png"
                        :show-file-list="false"
                        :data="index"
                        :on-success="handleAvatarSuccess"
                        :http-request="(file)=>{return commentUrlCutomUpload(file, index, 1)}"
                        :before-upload="logoUrlBeforeUpload">
                      <div v-if="comment[index].img1">
                        <img :src="comment[index].img1" class="avatar el-upload-list__item-thumbnail">
                        <div class="el-upload-list--picture-card ">
                            <span class="el-upload-list__item-actions">
                              <span class="el-upload-list__item-delete" @click.stop="handleRemove(index, 1)">
                                <i class="el-icon-delete"></i>
                              </span>
                            </span>
                        </div>
                      </div>
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <el-upload
                        class="avatar-uploader"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        accept="image/gif, image/jpeg, image/jpg, image/bmp, image/png"
                        :show-file-list="false"
                        :data="index"
                        :on-success="handleAvatarSuccess"
                        :http-request="(file)=>{return commentUrlCutomUpload(file, index, 2)}"
                        :before-upload="logoUrlBeforeUpload">
                      <div v-if="comment[index].img2">
                        <img :src="comment[index].img2" class="avatar el-upload-list__item-thumbnail">
                        <div class="el-upload-list--picture-card ">
                            <span class="el-upload-list__item-actions">
                              <span class="el-upload-list__item-delete" @click.stop="handleRemove(index, 2)">
                                <i class="el-icon-delete"></i>
                              </span>
                            </span>
                        </div>
                      </div>
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <el-upload
                        class="avatar-uploader"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        accept="image/gif, image/jpeg, image/jpg, image/bmp, image/png"
                        :show-file-list="false"
                        :data="index"
                        :on-success="handleAvatarSuccess"
                        :http-request="(file)=>{return commentUrlCutomUpload(file, index, 3)}"
                        :before-upload="logoUrlBeforeUpload">
                      <div v-if="comment[index].img3">
                        <img :src="comment[index].img3" class="avatar el-upload-list__item-thumbnail">
                        <div class="el-upload-list--picture-card ">
                            <span class="el-upload-list__item-actions">
                              <span class="el-upload-list__item-delete" @click.stop="handleRemove(index, 3)">
                                <i class="el-icon-delete"></i>
                              </span>
                            </span>
                        </div>
                      </div>
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <img class="link" src="@/assets/icons/link.svg" alt="" @click="addLink(index)">
                  </div>
                </div>
                <div class="comment_add_operation">
                  <div class="comment_add_button">
                    <el-button @click="cancelChildComment(index)">取消</el-button>
                    <el-button type="primary" @click="addChildComment(index)">发表</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-popover
              v-if='showPop'
              ref='pop'
              :reference='reference'
              placement="top"
              trigger="click"
              width="700"
          >
            <div class="popover_body">
              <div class="popover_head">
                <img v-if="!commentPop.header || commentPop.header === ''" src="@/assets/img/forum/forum_user.png" alt="">
                <img v-else :src="commentPop.header" alt="">
                <div class="popover_message">
                  <div>
                    <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width:160px" :title="commentPop.name">{{commentPop.name}}</div>
                    <div class="popover_tab">LV{{commentPop.level==null || commentPop.level === '0' ? '1' : commentPop.level}} {{commentPop.levelName}}</div>
                  </div>
                  <div style="color: #999999;font-size: 14px;padding-top: 14px;justify-content: flex-start">
                    <div style="width:120px">{{commentPop.levelRumenOrZhuanye === '0' ? '产品原型设计' : '车载应用开发'}}</div>
                    <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width:270px" :title="commentPop.introduce === null || commentPop.introduce === '' ? '暂无' : commentPop.introduce">个人介绍：{{commentPop.introduce === null || commentPop.introduce === '' ? '暂无' : commentPop.introduce}}</div>
                  </div>
                </div>
              </div>
              <div class="popover_foot">
                <div>已发布的应用数：{{commentPop.appSum}}</div>
                <div>已发布的场景数：{{commentPop.sceneSum}}</div>
                <div>经验值：{{commentPop.exp}}</div>
                <div>性别： {{commentPop.gender === '' || commentPop.gender === null || commentPop.gender === '0' ? '未公开' : (commentPop.gender === '1' ? '男' : '女')}}</div>
                <div>生日： {{!commentPop.birthDay || commentPop.birthDay === null || commentPop.birthDay === '' ? '未公开' : commentPop.birthDay}}</div>
              </div>
            </div>
          </el-popover>
          <div class="pagination">
            <el-pagination
                background
                :current-page.sync="currentPage"
                :page-size="pageSize"
                layout="prev, pager, next, total, jumper"
                :total="total"
                :hide-on-single-page="true"
                @current-change="handleCurrentChange">
            </el-pagination>
          </div>
          <div class="new_comment">
            <el-input v-model="newComment" style="display: none"></el-input>
            <el-upload
                :show-file-list="false"
                :before-upload="logoUrlBeforeUpload"
                :http-request="logoUrlCutomUpload"
                with-credentials
                accept="image/gif, image/jpeg, image/jpg, image/bmp, image/png"
                style="display: none"
            >
              <i id="imgInput" class="el-icon-plus avatar-uploader-icon" />
            </el-upload>
            <quill-editor
                ref="myQuillEditor"
                v-model="newComment"
                :options="editorOption"
                class="ql"
                @change="onEditorChange($event)"
            />
            <div class="reply">
              <el-button v-show="isEdit" @click="cancelEditComment">取消编辑</el-button>
              <el-button type="primary" @click="submitComment()">回复</el-button>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
    <el-dialog
        title=""
        :visible.sync="linkVisible"
        width="860px"
        center>
      <div style="text-align: center;font-size: 18px;">
        <div style="font-weight: bolder">超链接</div>
        <div style="padding: 24px 230px">
          <div style="display: flex;align-items: center;justify-content: space-between;font-size: 14px;margin-bottom: 20px">
            文本内容 <el-input v-model="textInput" style="width: 80%" placeholder="请输入"></el-input>
          </div>
          <div style="display: flex;align-items: center;justify-content: space-between;font-size: 14px;margin-bottom: 20px">
            链接地址 <el-input v-model="linkInput" style="width: 80%" placeholder="请输入"></el-input>
          </div>
          <el-checkbox v-model="checked">是否在新窗口打开</el-checkbox>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="border-radius: 18px;color: white;background-color: #4D78FF;border: 1px solid #4D78FF;width: 96px;height: 36px;line-height: 0" @click="insertLink(true)">确 定</el-button>
        <el-button style="border-radius: 18px;color: #4D78FF;background-color: white;border: 1px solid #4D78FF;width: 96px;height: 36px;line-height: 0" @click="insertLink(false)">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title=""
        :visible.sync="dialogVisible"
        width="50%"
        center>
      <div style="padding: 0 15%">
        <div style="width: 100%;text-align: center;font-size: 18px;color: black;padding: 8px;box-sizing: border-box">举报</div>
        <div style="width: 100%;text-align: center;font-size: 14px;color: #999999;padding: 10px;box-sizing: border-box">请选择举报理由</div>
        <div
            style="width: 100%;height: 100px;padding: 10px 0;display: flex;align-items: center;flex-wrap:wrap;margin-bottom: 10px"
            :style="radio === '其它' ? 'margin-bottom: 10px' : 'margin-bottom: 100px'">
          <el-radio v-model="radio" label="垃圾广告" style="width: 25%">垃圾广告</el-radio>
          <el-radio v-model="radio" label="违规内容" style="width: 25%">违规内容</el-radio>
          <el-radio v-model="radio" label="恶意灌水" style="width: 25%">恶意灌水</el-radio>
          <el-radio v-model="radio" label="重复发帖" style="width: 25%">重复发帖</el-radio>
          <el-radio v-model="radio" label="其它" style="width: 25%">其它</el-radio>
        </div>
        <div v-show="radio === '其它'">
          <el-input v-model="reason" style="border: 1px solid #999999;" :autosize="{ minRows: 4 }" type="textarea" placeholder="请填写举报原因"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="border-radius: 18px;color: white;background-color: #4D78FF;border: 1px solid #4D78FF;width: 96px;height: 36px;line-height: 0" @click="tipOffs()">确 定</el-button>
        <el-button style="border-radius: 18px;color: #4D78FF;background-color: white;border: 1px solid #4D78FF;width: 96px;height: 36px;line-height: 0" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <div v-if="showLargeImgVisible" class="el-image-viewer__wrapper" style="z-index: 100000;">
      <div class="el-image-viewer__mask"></div>
      <span class="el-image-viewer__btn el-image-viewer__close" @click="closeShowLargeImg"><i class="el-icon-circle-close"></i></span>
      <div class="el-image-viewer__canvas">
        <img :src="showLargeImgSrc" class="el-image-viewer__img" style="transform: scale(1) rotate(0deg); margin-left: 0px; margin-top: 0px; max-height: 100%; max-width: 100%;"><!---->
      </div>
    </div>
    <HomeFooter style="margin-top:0;position: relative;bottom: 0"/>
  </div>
</template>

<script>
import HomeHeader from '../../../components/HomeHeader'
import HomeFooter from '../../../components/HomeFooter'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor, Quill } from 'vue-quill-editor'
import {
  getChannel,
  getArticle,
  collection,
  tipOffs,
  countCollection,
  addComment,
  updateComment,
  thumbs,
  findPage,
  countThumbs,
  getComments,
  selectPersonalInfo,
  selectPersonalLevel,
  findComment,
  findComments,
  delArticle,
  delComment
} from '@/api/modules/forum'
import { getUploadKey } from '@/api/modules/api'
import COS from 'cos-js-sdk-v5'
const fontSizeStyle = Quill.import('attributors/style/size')
// fontSizeStyle.whitelist = ['10px', '12px', '14px', '16px', false, '20px', '22px', '24px', '26px', '28px', '30px', '32px', '36px', '38px', '40px', '45px', '50px']
fontSizeStyle.whitelist = ['14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px', '32px', '36px', false]
Quill.register(fontSizeStyle, true)
export default {
  name: 'ForumDetail',
  components: {
    HomeHeader,
    HomeFooter,
    quillEditor
  },
  data() {
    return {
      dialogImageUrl: '',
      photoShow: false,
      linkVisible: false,
      comment: [],
      currentPage: 1,
      pageSize: 10,
      total: '',
      newComment: '',
      dialogVisible: false,
      collectionFlag: 0,
      visible: false,
      authorAvatar: false,
      textarea: '',
      imageUrl: '',
      radio: '垃圾广告',
      divIndex: [],
      id: this.$route.query.id,
      detail: {
        userInfo: {}
      },
      list: [],
      commentOption: {
        modules: {
          clipboard: {
            // 粘贴版，处理粘贴时候带图片
            matchers: [[Node.ELEMENT_NODE, this.handleCustomMatcher]]
          },
          toolbar: []
        },
        placeholder: ''
      },
      TiLength: 0,
      editorOption: {
        modules: {
          clipboard: {
            // 粘贴版，处理粘贴时候带图片
            matchers: [[Node.ELEMENT_NODE, this.handleCustomMatcher]]
          },
          toolbar: {
            container: [
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'size': fontSizeStyle.whitelist }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'list': 'bullet' }, { 'list': 'ordered' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'clean': '源码编辑' }],
              ['link', 'image'],
              [{ 'header': 1 }, { 'header': 2 }],
              ['blockquote', 'code-block'],
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }]
            ]
          }
        },
        placeholder: '编辑回复内容...'
      },
      reference: {},
      // 控制渲染条件 如果不用v-if会报错 具体可自行尝试
      showPop: false,
      // 保存当前激活的refrence id
      activeId: '',
      targetType: 'article',
      userId: this.getCookie('userid'),
      userInfo: null,
      reportForm: {},
      addRange: '',
      articleTotal: 0,
      thumbsFlag: 0,
      reason: '',
      textInput: '',
      linkInput: '',
      checked: false,
      myEditor: null,
      myEditorRange: null,
      level: ['1'],
      authorInfoPop: {},
      seeAllFlag: 0,
      channelName: '频道',
      editCommentData: null,
      commentPop: {},
      contentPagination: [],
      isEdit: false,
      showLargeImgVisible: false,
      showLargeImgSrc: ''
    }
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    },
    collectionName() {
      return this.collectionFlag === 1 ? '取消收藏' : '收藏'
    },
    seeAll() {
      return this.seeAllFlag === 1 ? '查看全部' : '只看楼主'
    }
  },
  async created() {
    await this.getArticle()
    await this.getComments()
    if (this.getCookie('userid')) {
      this.countCollection()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.stockBlot()
      this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', this.imgHandler)
    })
    window.showLarge = this.showLarge
    this.initButton()
  },
  methods: {

    initButton() {
      document.querySelector('.ql-italic').title = '倾斜\n将所选内容字体设置为倾斜'
      document.querySelector('.ql-underline').title = '下划线\n给所选文字内容添加下划线'
      document.querySelector('.ql-strike').title = '删除线\n给所选文字内容添加删除线'
      document.querySelectorAll('.ql-picker-item')[0].title = '字符样式\n将所选内容设置为标题1样式'
      document.querySelectorAll('.ql-picker-item')[1].title = '字符样式\n将所选内容设置为标题2样式'
      document.querySelectorAll('.ql-picker-item')[2].title = '字符样式\n将所选内容设置为标题3样式'
      document.querySelectorAll('.ql-picker-item')[3].title = '字符样式\n将所选内容设置为标题4样式'
      document.querySelectorAll('.ql-picker-item')[4].title = '字符样式\n将所选内容设置为标题4样式'
      document.querySelectorAll('.ql-picker-item')[5].title = '字符样式\n将所选内容设置为标题4样式'
      document.querySelectorAll('.ql-picker-item')[6].title = '字符样式\n将所选内容设置为正文样式'
      document.querySelectorAll('.ql-header')[2].title = '字符样式\n将所选内容设置为标题1样式'
      document.querySelectorAll('.ql-header')[3].title = '字符样式\n将所选内容设置为标题2样式'
      document.querySelectorAll('.ql-list')[0].title = '项目符号\n给所选段落添加项目符号'
      document.querySelectorAll('.ql-list')[1].title = '编号格式\n给所选段落添加编号'
      document.querySelectorAll('.ql-script')[0].title = '下标\n在文本行下方添加小字符'
      document.querySelectorAll('.ql-script')[1].title = '上标\n在文本行上方添加小字符'
      document.querySelectorAll('.ql-indent')[0].title = '减少缩进量\n减少段落缩进量'
      document.querySelectorAll('.ql-indent')[1].title = '增加缩进量\n增加段落缩进量'
      document.querySelector('.ql-color').title = '字体颜色\n设置文字的颜色'
      document.querySelector('.ql-link').title = '插入链接\n对所选内容添加链接'
      document.querySelector('.ql-background').title = '字符底纹\n给所选内容添加底纹'
      document.querySelectorAll('.ql-align')[0].title = '左对齐\n段落左对齐'
      document.querySelectorAll('.ql-align')[1].title = '居中对齐\n段落居中对齐'
      document.querySelectorAll('.ql-align')[2].title = '右对齐\n段落右对齐'
      document.querySelectorAll('.ql-align')[3].title = '两端对齐\n将文字左右两端同时进\n行对齐，并根据需要增\n加字间距'
      document.querySelector('.ql-bold').title = '加粗\n将所选内容字体加粗'
      document.querySelector('.ql-clean').title = '清除文本格式\n清除所选内容的文本格式'
      document.querySelector('.ql-video').title = '插入视频\n在所选区域添加视频'
      document.querySelector('.ql-fullscreen1').title = '全屏\n编辑区域最大化，再次点击撤销最大化'
      document.querySelector('.ql-sourceEditor').title = '插入素材\n在所选位置插入素材'
      document.querySelector('.ql-sourceEditorInsertFile').title = '导入文档\n在所选位置导入文档'
      document.querySelector('.ql-blockquote').title = '引用\n将所选内容设置为引用'
    },
    onEditorChange(e) {
      e.quill.deleteText(5000, 10)
      if (this.newComment === '') {
        this.TiLength = 0
      }
      else {
        this.TiLength = e.quill.getLength() - 1
      }
    },

    isLogin() {
      if (!this.getCookie('userid')) {
        this.$router.push('/login')
        return false
      }
      else {
        return true
      }
    },
    handleCustomMatcher(node, Delta) {
      console.log(666)
      const ops = []
      Delta.ops.forEach(op => {
        if (op.insert && typeof op.insert === 'string') { // 如果粘贴了图片，这里会是一个对象，如果是字符串则可以添加
          ops.push({
            insert: op.insert
          })
        }
        else { // 给出提醒
          if (this.isEdit) {
            ops.push({
              insert: op.insert
            })
            return
          }
          this.$message({
            message: '不允许粘贴图片,请手动上传',
            type: 'warning',
            offset: 80
          })
        }
      })
      Delta.ops = ops
      return Delta
    },
    editNewComment(item) {
      this.isEdit = true
      this.newComment = item.content
      this.editCommentData = item
      this.$refs.myQuillEditor.quill.focus()
    },
    toDetail() {
      this.$router.push({
        path: '/forum/edit',
        query: { id: this.id }
      })
    },
    async delComment(id, text) {
      this.$confirm(`此操作将删除该${text}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await delComment(id)
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '删除成功!',
            offset: 80
          })
          location.reload()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          offset: 80
        })
      })
    },
    async delArticle() {
      this.$confirm('此操作将删除该文章, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await delArticle(this.id)
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '删除成功!',
            offset: 80
          })
          await this.$router.push('/forum')
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          offset: 80
        })
      })
    },
    async getChannel() {
      const res = await getChannel(this.detail.channelIds[0])
      this.channelName = res.data.name
    },
    async findComments() {
      this.seeAllFlag = this.seeAllFlag === 1 ? 0 : 1
      if (this.seeAllFlag === 1) {
        const data = {
          articleId: this.id,
          userId: this.detail.authorId
        }
        const res = await findComments(data)
        this.list = res.data
        return
      }
      await this.getComments()
    },
    async selectPersonalInfo(id) {
      const data = {
        userId: id
      }
      const res = await selectPersonalInfo(data)
      if (res.code === 0) {
        this.authorInfoPop = res.data
      }
    },
    async findComment() {
      const data = {}
      const res = await findComment(data)
      console.log(res)
    },
    async selectPersonalLevel(list) {
      const data = {
        userIdList: list
      }
      const res = await selectPersonalLevel(data)
      if (res.code === 0) {
        this.level = res.data
      }
    },
    cancelChildComment(index) {
      this.divIndex.splice(this.divIndex.indexOf(index), 1)
    },
    // 自定义blot
    stockBlot() {
      // 引入源码中的BlockEmbed
      const BlockEmbed = Quill.import('formats/link')
      // 定义新的blot类型
      class StockEmbed extends BlockEmbed {
        static create(value) {
          let node = null
          if (value && !value.href) {
            // 适应原本的Link Blot
            node = super.create(value)
          }
          else {
            // 自定义Link Blot
            node = super.create(value.href)
            node.href = value.href
            node.innerText = value.innerText
            node.target = value.target
          }
          return node
        }
      }
      StockEmbed.blotName = 'StockEmbed'
      StockEmbed.tagName = 'A'
      Quill.register(StockEmbed, true)
    },
    addLink(index) {
      this.myEditorRange = this.$refs[`commentQuillEditor${index}`][0].quill.getSelection()
      this.myEditor = this.$refs[`commentQuillEditor${index}`][0].quill
      this.linkVisible = true
    },
    insertLink(flag) {
      if (flag) {
        const target = this.checked ? '_blank' : '_self'
        // const link = `<a href="${this.linkInput}" rel="noopener noreferrer" target="${target}">${this.textInput}</a>`
        this.myEditor.insertEmbed(
          this.myEditorRange !== null ? this.myEditorRange.index : 0,
          'StockEmbed',
          { href: this.linkInput, innerText: this.textInput, target: target },
          'api'
        )
      }
      this.linkInput = ''
      this.textInput = ''
      this.checked = false
      this.linkVisible = false
    },
    async addChildComment(index) {
      if (this.comment[index].content === '' && this.comment[index].img1 === '' && this.comment[index].img2 === '' && this.comment[index].img3 === '') {
        this.$message({
          message: '回复内容或图片不能为空',
          type: 'warning',
          offset: 80
        })
        return
      }
      const contentArray = this.comment[index].content.split('</p>')
      let imgUrl = this.comment[index].img1 === '' ? '' : `<a href="${this.comment[index].img1}" data-fancybox><img src="${this.comment[index].img1}"></a>`
      imgUrl = imgUrl + (this.comment[index].img2 === '' ? '' : `<a href="${this.comment[index].img2}" data-fancybox data-caption="This image has a caption"><img src="${this.comment[index].img2}"></a>`)
      imgUrl = imgUrl + (this.comment[index].img3 === '' ? '' : `<a href="${this.comment[index].img3}" data-fancybox data-caption="This image has a caption"><img src="${this.comment[index].img3}"></a>`)
      const resultContent = (contentArray[0] === '' ? '<p>' : contentArray[0]) + imgUrl + '</p>'
      const data = {
        content: resultContent,
        targetId: this.comment[index].targetId,
        targetType: this.comment[index].targetType,
        userId: this.comment[index].userId
      }
      const res = await addComment(data)
      if (res.code === 0) {
        await this.$message({
          message: '评论成功',
          type: 'success',
          offset: 80
        })
        location.reload()
      }
      else {
        await this.$message({
          message: res.msg,
          type: 'error',
          offset: 80
        })
        location.reload()
      }
    },
    async findPage() {
      const data = {
        authorId: this.detail.authorId,
        status: '2'
      }
      const res = await findPage(data, 1, 100)
      if (res.code === 0) {
        this.articleTotal = res.total
      }
    },
    getCookie(cname) {
      var name = cname + '='
      var ca = document.cookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1)
        if (c.indexOf(name) !== -1) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    },
    isNull(str) {
      if (str === '') return true
      var regu = '^[ ]+$'
      var re = new RegExp(regu)
      return re.test(str)
    },
    async tipOffs() {
      const data = this.reportForm
      data.userId = this.userId
      data.type = this.radio
      if (data.type === '其它') {
        if (this.isNull(this.reason)) {
          await this.$message({
            message: '请填写原因',
            type: 'warning',
            offset: 80
          })
          return
        }
        data.reason = this.reason
      }
      const res = await tipOffs(data)
      if (res.code === 0) {
        await this.$message({
          message: '举报成功',
          type: 'success',
          offset: 80
        })
        this.radio = '垃圾广告'
        this.reason = ''
        this.dialogVisible = false
      }
    },
    async countCollection() {
      const data = {
        targetId: this.id,
        userId: this.userId,
        targetType: 'article'
      }
      const res = await countCollection(data)
      if (res.code === 0) {
        this.collectionFlag = res.data
      }
    },
    async collection(id) {
      if (!this.isLogin()) {
        return
      }
      const data = {
        targetId: id,
        targetType: this.targetType,
        userId: this.userId
      }
      const res = await collection(data)
      if (res.code === 0) {
        this.collectionFlag = this.collectionFlag === 1 ? 0 : 1
        if (this.collectionFlag === 1) {
          await this.$message({
            message: '收藏成功',
            type: 'success',
            offset: 80
          })
          return
        }
        await this.$message({
          message: '取消收藏成功',
          type: 'success',
          offset: 80
        })
      }
    },
    async clickPop(item, user) {
      // 这个操作是为了避免与源码中的点击reference doToggle方法冲突
      if (this.activeId === item && this.showPop) return
      const data = {
        userId: user.id
      }
      const res = await selectPersonalInfo(data)
      if (res.code === 0) {
        this.commentPop = res.data
        this.commentPop.name = user.name
        this.commentPop.header = user.headPortrait
      }
      this.showPop = false
      this.activeId = item
      // 因为reference是需要获取dom的引用 所以需要是$el
      this.reference = this.$refs['bt' + item][0]
      this.$nextTick(() => {
        // 等待显示的popover销毁后再 重新渲染新的popover
        this.showPop = true
        this.$nextTick(() => {
          // 此时才能获取refs引用
          this.$refs.pop.doShow()
        })
      })
    },
    imgHandler(state) {
      this.addRange = this.editor.getSelection()
      if (state) {
        const fileInput = document.getElementById('imgInput')
        fileInput.click()
      }
    },
    logoUrlBeforeUpload(file) {
      console.log('file', file)
      if (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/gif') {
        return true
      }
      this.$message({
        message: '文件格式有误',
        type: 'error',
        offset: 90
      })
      return false
    },
    async logoUrlCutomUpload(data) {
      const { file } = data
      const res = await getUploadKey(0)
      const cosKey = res.data
      const cosKlg = new COS({
        getAuthorization: (options, callback) => {
          callback({
            TmpSecretId: cosKey.secretId,
            TmpSecretKey: cosKey.secretKey,
            XCosSecurityToken: cosKey.token,
            ExpiredTime: cosKey.expireTime
          })
        }
      })
      const key = 'web/img/' + new Date().getTime() + '-' + file.name
      cosKlg.putObject({
        Bucket: cosKey.bucket, // 指定桶参数coskey参
        Region: cosKey.region,
        Key: key, // this.sourcePath
        ContentType: 'application/octet-stream',
        StorageClass: 'STANDARD',
        Body: file,
        onProgress: function(progressData) {
          console.log(JSON.stringify(progressData))
        }
      }, (err, data) => {
        // this.catalogueProperties.newLogoKey = key
        this.addRange = this.editor.getSelection()
        // 调用编辑器的 insertEmbed 方法，插入图片URL到编辑器图片对应位置
        // 第一个参数index 光标位置索引
        this.editor.insertEmbed(
          this.addRange !== null ? this.addRange.index : 0,
          'image',
          'http://' + data.Location
        )
        console.log(err || data)
      })
    },
    async commentUrlCutomUpload(data, index, imgIndex) {
      const { file } = data
      const res = await getUploadKey(0)
      const cosKey = res.data
      const cosKlg = new COS({
        getAuthorization: (options, callback) => {
          callback({
            TmpSecretId: cosKey.secretId,
            TmpSecretKey: cosKey.secretKey,
            XCosSecurityToken: cosKey.token,
            ExpiredTime: cosKey.expireTime
          })
        }
      })
      const key = 'web/img/' + new Date().getTime() + '-' + file.name
      cosKlg.putObject({
        Bucket: cosKey.bucket, // 指定桶参数coskey参
        Region: cosKey.region,
        Key: key, // this.sourcePath
        ContentType: 'application/octet-stream',
        StorageClass: 'STANDARD',
        Body: file,
        onProgress: function(progressData) {
          console.log(JSON.stringify(progressData))
        }
      }, (err, data) => {
        this.comment[index][`img${imgIndex}`] = 'http://' + data.Location
        this.$forceUpdate()
        this.$message({
          message: '上传成功',
          type: 'success',
          offset: 80
        })
        console.log(err || data)
      })
    },
    handleRemove(index, imgIndex) {
      this.comment[index][`img${imgIndex}`] = null
      this.$forceUpdate()
    },
    showComment(item, index) {
      if (!this.isLogin()) {
        return
      }
      if (this.divIndex.indexOf(index) === -1) {
        this.divIndex.push(index)
      }
      this.comment[index] = {
        targetId: item.id,
        content: '',
        targetType: 'comment',
        userId: this.userId,
        img1: '',
        img2: '',
        img3: ''
      }
      this.$nextTick(() => {
        this.$refs[`commentQuillEditor${index}`][0].quill.focus()
      })
    },
    async updateComment() {
      const data = {
        id: this.editCommentData.id,
        content: this.newComment,
        userId: this.userId,
        targetId: this.editCommentData.targetId,
        targetType: this.editCommentData.targetType
      }
      const res = await updateComment(data)
      if (res.code === 0) {
        await this.$message({
          message: '编辑成功',
          type: 'success',
          offset: 80
        })
        location.reload()
      }
      else {
        await this.$message({
          message: `${res.msg}`,
          type: 'error',
          offset: 80
        })
        location.reload()
      }
    },
    cancelEditComment() {
      this.isEdit = false
      this.editCommentData = null
      this.newComment = ''
      this.$refs.top.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' })
    },
    submitComment() {
      if (!this.isLogin()) {
        return
      }
      this.isEdit = false
      if (this.editCommentData) {
        this.updateComment()
      }
      else {
        this.addComment('article')
      }
    },
    async addComment(type) {
      const data = {
        targetId: this.id,
        targetType: type,
        userId: this.userId,
        content: this.newComment
      }
      const res = await addComment(data)
      if (res.code === 0) {
        await this.$message({
          message: '回复成功',
          type: 'success',
          offset: 80
        })
        location.reload()
        return
      }
      await this.$message({
        message: `${res.msg}`,
        type: 'error',
        offset: 80,
        onClose: () => {
          location.reload()
        }
      })
    },
    report(id, type) {
      if (!this.isLogin()) {
        return
      }
      this.reportForm.targetId = id
      this.reportForm.targetType = type
      this.dialogVisible = true
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    async getArticle() {
      const res = await getArticle(this.id)
      if (res.code === 0) {
        this.detail = res.data
        if (this.getCookie('userid')) {
          await this.countThumbs()
        }
        await this.getChannel()
        await this.findPage()
        await this.selectPersonalInfo(res.data.authorId)
      }
    },
    timeFormatSeconds(time) {
      var d = time ? new Date(time) : new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hours = d.getHours()
      var min = d.getMinutes()
      var seconds = d.getSeconds()

      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      if (hours < 0) hours = '0' + hours
      if (min < 10) min = '0' + min
      if (seconds < 10) seconds = '0' + seconds

      return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds)
    },
    async commentThumbs(item, index, childrenIndex = null) {
      if (!this.isLogin()) {
        return
      }
      // if (this.userId === item.userInfo.id) {
      //   await this.$message({
      //     message: '不能给自己点赞',
      //     type: 'error',
      //     offset: 80
      //   })
      //   return
      // }
      const data = {
        targetId: item.id,
        targetType: 'comment',
        userId: this.userId
      }
      const res = await thumbs(data)
      if (res.code === 0) {
        if (childrenIndex !== null) {
          this.contentPagination[index].list[childrenIndex].isThumbs = this.contentPagination[index].list[childrenIndex].isThumbs === 1 ? 0 : 1
          // this.list[index].children[childrenIndex].isThumbs = this.list[index].children[childrenIndex].isThumbs === 1 ? 0 : 1
          if (this.contentPagination[index].list[childrenIndex].isThumbs === 1) {
            this.contentPagination[index].list[childrenIndex].thumbs += 1
            await this.$message({
              message: '点赞成功',
              type: 'success',
              offset: 80
            })
            this.$forceUpdate()
            return
          }
          this.contentPagination[index].list[childrenIndex].thumbs -= 1
          this.$forceUpdate()
          await this.$message({
            message: '取消点赞成功',
            type: 'success',
            offset: 80
          })
        }
        else {
          this.list[index].isThumbs = this.list[index].isThumbs === 1 ? 0 : 1
          if (this.list[index].isThumbs === 1) {
            this.list[index].thumbs += 1
            await this.$message({
              message: '点赞成功',
              type: 'success',
              offset: 80
            })
            return
          }
          this.list[index].thumbs -= 1
          await this.$message({
            message: '取消点赞成功',
            type: 'success',
            offset: 80
          })
        }
      }
    },
    async thumbs() {
      if (!this.isLogin()) {
        return
      }
      // if (this.userId === this.detail.authorId) {
      //   await this.$message({
      //     message: '不能给自己点赞',
      //     type: 'error',
      //     offset: 80
      //   })
      //   return
      // }
      const data = {
        targetId: this.id,
        targetType: 'article',
        userId: this.userId
      }
      const res = await thumbs(data)
      if (res.code === 0) {
        this.thumbsFlag = this.thumbsFlag === 1 ? 0 : 1
        if (this.thumbsFlag === 1) {
          await this.$message({
            message: '点赞成功',
            type: 'success',
            offset: 80
          })
          this.detail.thumbs = this.detail.thumbs + 1
          return
        }
        this.detail.thumbs = this.detail.thumbs - 1
        await this.$message({
          message: '取消点赞成功',
          type: 'success',
          offset: 80
        })
      }
    },
    async countThumbs() {
      const data = {
        targetId: this.id,
        targetType: 'article',
        userId: this.userId
      }
      const res = await countThumbs(data)
      if (res.code === 0) {
        this.thumbsFlag = res.data
      }
    },
    async getComments() {
      const data = {
        targetId: this.id,
        targetType: 'article',
        status: '0'
      }
      const res = await getComments(data, this.currentPage, this.pageSize, this.userId)
      if (res.code === 0) {
        this.list = res.data
        this.total = res.total
        const user = [this.detail.authorId]
        this.list.forEach((item, index) => {
          user.push(item.userInfo.id)
          this.contentPagination[index] = {
            list: item.children ? item.children : [],
            showFlag: false,
            total: 3
          }
        })
        await this.selectPersonalLevel(user)
      }
    },
    handleCurrentChange() {
      this.getComments()
      setTimeout(() => {
        this.$refs.top.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' })
      }, 300)
    },
    async showAllComment(index, id) {
      if (!this.contentPagination[index].pageNum) {
        this.contentPagination[index].pageNum = 1
      }
      const data = {
        targetId: id,
        targetType: 'comment',
        status: 0
      }
      const res = await findComment(data, this.contentPagination[index].pageNum, 8)
      if (res.code === 0) {
        this.contentPagination[index].list = res.data
        this.contentPagination[index].list.forEach((item, indexNew) => {
          this.contentPagination[index].list[indexNew].userInfo.name = item.nickName
        })
        this.contentPagination[index].total = res.total
        this.contentPagination[index].showFlag = true
        this.$forceUpdate()
        this.$refs[`comment${index}`][0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' })
      }
    },
    hideAllComment(index) {
      this.contentPagination[index].list = this.list[index].children
      this.contentPagination[index].total = 0
      this.contentPagination[index].showFlag = false
      this.$forceUpdate()
      this.$refs[`comment${index}`][0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' })
    },
    showLarge(src) {
      this.showLargeImgVisible = true
      this.showLargeImgSrc = src
    },
    closeShowLargeImg() {
      this.showLargeImgVisible = false
      this.showLargeImgSrc = ''
    }
  }
}
</script>

<style scoped>
.comment{
  background-color: #FFFFFF;
  width: 100%;
  display: flex;
  color: #2F374B;
  min-height: 279px;
  border-top: 1px solid #DDDDDD;
}
.content{
  background-color: #FFFFFF;
  width: 100%;
  display: flex;
  color: #2F374B;
}
/deep/.content > p {
  line-height: 1.4;
  word-break: break-all;
  display: flex;
  align-items: center;
}
/*/deep/.content > p > * {*/
/*  vertical-align: bottom;*/
/*}*/
/deep/.content > p > img{
  max-height: 30px;
  margin: auto 10px;
}
/deep/.content > p > a > img{
  max-height: 30px;
  margin: auto 10px;
}
/deep/.content > p > a{
  color: #4d78ff;
}
/deep/.comment_first_content > p > a {
  color: #4d78ff;
}
/deep/.comment_first_content > p > img {
  max-width: 100%;
}
.content_left{
  padding: 20px;
  box-sizing: border-box;
  width: 220px;
  height: 100%;
}
.content_user{
  background: url('~@/assets/img/forum/author_bg.png') no-repeat center bottom / 100% auto;
  width: 180px;
  height: 240px;
  padding: 18px 36px;
  box-sizing: border-box;
}
.comment_user{
  background: url('~@/assets/img/forum/user_bg.png') no-repeat center bottom / 100% auto;
  width: 180px;
  height: 240px;
  padding: 18px 36px;
  box-sizing: border-box;
}
.content_img{
  box-sizing: border-box;
  padding: 13px 17px 20px 22px;
}
.content_img > img {
  border-radius: 50%;
  width: 69px;
  height: 69px;
}
.content_name{
  text-align: center;
  font-size: 18px;
  color: #2F374B;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.content_tab{
  padding: 12px 0;
  text-align: center;
}
.popover_tab{
  border: 1px solid #4D78FF;
  font-size: 14px;
  line-height: 1;
  border-radius: 12px;
  padding: 5px 10px;
  box-sizing: border-box;
  color: #4D78FF;
  margin-left: 20px;
}
.content_tab > div{
  border: 1px solid #4D78FF;
  font-size: 14px;
  line-height: 1;
  border-radius: 12px;
  padding: 5px 8px;
  box-sizing: border-box;
  color: #4D78FF;
}
.content_message{
  padding: 10px 0px 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.content_message > span {
  font-size: 18px;
}
/deep/.el-divider{
  background-color: black;
  height: 20px;
}
.content_right{
  padding: 26px 50px 26px 0;
  /*padding: 26px 0;*/
  width: 1290px;
}
.comment_right{
  padding: 20px 0;
  width: 1290px;
}
.title{
  font-size: 20px;
  line-height: 30px;
}
.tab{
  display: inline-block;
  border: 1px solid #59C264;
  height: 25px;
  box-sizing: border-box;
  padding: 5px 8px;
  font-size: 14px;
  border-radius: 12px;
  line-height: 1;
  color: #59C264;
  background-color: #F0FFF2;
  margin-left: 10px;
}
.tab1{
  display: inline-block;
  border: 1px solid #EFA13E;
  height: 25px;
  box-sizing: border-box;
  padding: 5px 8px;
  font-size: 14px;
  border-radius: 12px;
  line-height: 1;
  color: #EFA13E;
  background-color: #FEF7EE;
  margin-left: 10px;
}
.time{
  display: flex;align-items: center;width: 360px;color: #999999;font-size: 14px;justify-content: space-between
}
.button{
  padding: 24px 0;
  width: 122px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  color:  #4D78FF;
  font-size: 14px;
}
.button > div:hover {
  cursor: pointer;
  color: #365DD9;
}
.detail{
  width: 100%;
  min-height: 180px !important;
  padding: 12px 0;
  box-sizing: border-box;
  height: unset !important;
}
.operation{
  display: flex;
  align-items: center;
  float: right;
}
/deep/.el-button{
  border: 1px solid #4D78FF;
  width: 96px;
}
.comment_first{
  padding: 9px 20px 9px 0;
  font-size: 16px;
}
.comment_first_content{
  color: #2F374B;
  margin-bottom: 10px;
}
.comment_first_time{
  width: 410px;
  color: #999999;
}
.comment_first_operation{
  align-items: center;
  display: flex;
  /*width: 100px;*/
}
.operation > img {
  cursor: pointer;
}
.comment_first_operation > img {
  cursor: pointer;
}
.comment_return{
  padding: 10px 0;
  min-height: 60px;
}
.comment_return_content{
  display: flex;
  align-items: center;
}
.comment_return_content>img{
  height: 30px;
  width: 30px;
}
.comment_return_content>.name{
  font-size: 18px;
  color: #2F374B;
  border-right: 1px solid #2F374B;
  padding: 0 8px;
  min-width: 75px;
  box-sizing: border-box;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.comment_return_content>.content{
  font-size: 16px;
  color: #2F374B;
  padding: 0 10px;
}
.comment_return_time{
  padding: 11px 0;
  color: #999999;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.comment_return_time>.button{
  padding: 0 16px;
  display: flex;
  align-items: center;
  width: 50px;
  box-sizing: border-box;
  justify-content: space-between;
  cursor: pointer;
}
.comment_add{
  min-height: 150px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #DDDDDD;
  padding-bottom: 5px;
}
/deep/.el-textarea__inner{
  resize: none;
  border: unset;
}
.upload{
  padding: 0 6px;
  display: flex;
  align-items: center;
}
.upload>.link{
  cursor: pointer;
  width: 26px;
  height: 26px;
}
.avatar-uploader {
  margin: 0 4px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  width: 42px;
  height: 42px;
  position: relative;
  overflow: hidden;
}
.avatar-uploader:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  color: #C2C2C2;
  width: 42px;
  height: 42px;
  line-height: 42px;
  text-align: center;
}
.avatar {
  width: 42px;
  height: 42px;
  display: block;
}
.pagination{
  padding: 28px 0;
  text-align: right;
}
.comment_pagination {
  text-align: left;
}
/deep/.el-pagination__total{
  font-size:12px;
  color: #999999;
}
/deep/.el-pagination__jump{
  font-size:12px;
  color: #999999;
}
/deep/.el-input__inner{
  color: #999999;
  font-size: 12px;
}
.new_comment{
  padding: 40px 0;
}
/deep/ .ql-editor{
  background-color: #FFFFFF;
  min-height: 480px;
}
.reply{
  text-align: right;
  padding: 24px 0;
}
.comment_add_button{
  display: flex;
  width: 210px;
  align-items: center;
  justify-content: space-between;
}
.comment_add_operation{
  padding: 10px 0;
  float: right;
}
.comment_div{
  padding-right: 10px;
  box-sizing: border-box;
}
.popover_body{
  height: 210px;width: 100%;padding: 16px 40px;box-sizing: border-box
}
.popover_head{
  padding: 0 90px;height: 90px;width: 100%;box-sizing: border-box;display: flex;align-items: center;
}
.popover_head > img {
  width: 88px;height: 88px;
}
.popover_foot {
  padding-top: 10px;
  display: flex;
  height: 80px;
  flex-wrap: wrap;
  align-content: space-around;
  justify-content: flex-start;
}
.popover_foot > div{
  width: 33%;
}
.popover_message{
  padding-left: 27px;
}
.popover_message > div{
  font-size: 20px;
  color: #2F374B;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cancelCollection{
  color: #999999;
}
/deep/.el-radio__input.is-checked+.el-radio__label{
  color: #4D78FF;
}
/deep/.el-radio__input.is-checked .el-radio__inner{
  background: white;
}/deep/.el-radio__inner{
   width: 16px;
   height: 16px;
 }
/deep/.el-radio__inner::after{
  width: 10px;
  height: 10px;
  background-color: #4D78FF;
}
/deep/.detail > p > img{
  max-width: 100%;
}
/deep/.comment_add > .quill-editor > .ql-toolbar.ql-snow {
  display: none;
}
/deep/.comment_add > .quill-editor > .ql-container.ql-snow {
  border: unset;
}
/deep/.comment_add > .quill-editor > .ql-container.ql-snow > .ql-editor {
  min-height: 130px;
}
/deep/.comment_add > .quill-editor > .ql-container.ql-snow > .ql-tooltip {
  display: none;
}
.allContent > p {
  width: 150px;
  cursor:pointer;
  color: #4d78ff;
}
.allContent > p:hover{
  color: #003A6F;
}
/deep/.comment_pagination > ul > li{
  border-radius: 50% !important;
}
/deep/.comment_pagination > button{
  border-radius: 50% !important;
}
.showLargeImg-class {
  height: 700px;
}
</style>
<style lang="less" scoped>
/deep/ .ql{
  .ql-snow .ql-picker.ql-header,
  .ql-snow .ql-picker.ql-size {
    box-sizing: border-box;
    border: 1px solid #D2DBEA;
  }
  .ql-snow.ql-toolbar button:hover,
  .ql-snow .ql-toolbar button:hover,
  .ql-picker-item:hover {
    background: #F4F5F7;
  }
  .ql-picker-item {
    padding-left: 6px;
  }
  .ql-snow.ql-toolbar button.ql-active {
    background: #E7EBEF;
  }
  .ql-toolbar.ql-snow {
    margin: 0 auto;
    background: #ffffff;
  }

  .ql-snow .ql-color-picker .ql-picker-label svg, .ql-snow .ql-icon-picker .ql-picker-label svg{margin-bottom:-2px;}
  .ql-snow .ql-picker-label::before{position:relative;top:0px;}
  .ql-snow .ql-tooltip[data-mode=link]::before {content: "请输入链接地址:"; left: 20px !important;}
  .ql-snow .ql-tooltip[data-mode=link] { left: 20px !important;}
  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label, .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options{border-color: none; padding: 4px 0;}
  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label{border-color: none; padding: 0 8px;}
  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
  }

  .ql-snow .ql-tooltip[data-mode=video]::before {content: "请输入视频地址:";}

  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {content: '14px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {content: '10px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {content: '18px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {content: '32px';}

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='10px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='10px']::before {content: '10px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='12px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='12px']::before {content: '12px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='14px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='14px']::before {content: '14px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='16px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='16px']::before {content: '16px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='18px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='18px']::before {content: '18px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='20px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='20px']::before {content: '20px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='22px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='22px']::before {content: '22px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='24px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='24px']::before {content: '24px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='26px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='26px']::before {content: '26px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='28px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='28px']::before {content: '28px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='30px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='30px']::before {content: '30px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='32px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='32px']::before {content: '32px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='34px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='34px']::before {content: '34px';}
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='36px']::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='36px']::before {content: '36px';}
  .ql-snow .ql-picker.ql-header .ql-picker-item::before {font-size: 12px;font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {font-size: 28px;font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {font-size: 24px;font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {font-size: 20px;font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {font-size: 16px;font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {font-size: 14px;font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {font-size: 12px;font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-label::before {content: '正文';font-family: PingFangSC-Regular;font-weight: 400;font-size: 14px;color: #4B5D7B;}
  .ql-snow .ql-picker.ql-header .ql-picker-item::before {content: '正文';font-weight: 400;color: #444444;}
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {content: '标题1';}
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {content: '标题2';}
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {content: '标题3';}
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {content: '标题4';}
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {content: '标题5';}
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {content: '标题6';}

  // .ql-snow .ql-picker.ql-font .ql-picker-label::before,
  // .ql-snow .ql-picker.ql-font .ql-picker-item::before {content: '标准字体';}
  // .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
  // .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {content: '衬线字体';}
  // .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
  // .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {content: '等宽字体';}

  // .ql-snow .ql-picker-label:before, .ql-snow .ql-picker.ql-size .ql-picker-item:before, .ql-snow .ql-picker.ql-size .ql-picker-label:before{top:-7px}
}
</style>
